import { default as Icon, IconProps } from 'interface/Icon';

const icon = (props: IconProps) => <Icon icon="ability_rogue_quickrecovery" {...props} />;
export default icon;
